export const handleDownload = (filePath) => {
  let fetchFile = function (url) {
    return fetch(url, {
      "Access-Control-Allow-Origin": "*",
      //   host: "sbox-backend.s3.ap-south-1.amazonaws.com",
      //   origin: "https://sbox-backend.s3.ap-south-1.amazonaws.com",
    })
      .then((res) => res.blob())
      .catch((err) => console.log(err));
  };

  let exportFile = function (file) {
    let a = document.createElement("a");
    a.href = URL.createObjectURL(file);

    a.setAttribute("download", "vip_pass");
    a.click();
  };

  fetchFile(filePath)
    .then((file) => exportFile(file))
    .catch((err) => console.log(err));
};
